import http from "./http";

export const getSubscriptionAlerts = async () => {
  try {
    const res = await http.get("admin/subscription_alerts");
    return res.data;
  } catch (error) {
    return {
      status: false,
      message: error.message,
    };
  }
};